import { UserRole } from '../../../../../../../users/roles';
import { OrderType } from '../../../../../../interfaces/orderType.enum';
import { OrderCondition } from '../../../../../interfaces/orderCondition.interface';
import OrderConditionCustomFieldConfig from '../../../../../interfaces/orderConditionCustomFieldConfig.interface';
import { FilterCustomFieldsByOrderConditionAndUserRoleParams } from '../types/orderConditionCustomFields.types';

const useFilterOrderConditionCustomFields = () => {
  const filterCustomFieldsByOrderCondition = (
    customFields: OrderConditionCustomFieldConfig[],
    orderCondition: OrderCondition,
  ): OrderConditionCustomFieldConfig[] => {
    const filtered = customFields.filter(
      ({ orderType: fieldOrderType }) =>
        [fieldOrderType, orderCondition.orderType].includes(OrderType.BOTH) ||
        fieldOrderType === orderCondition.orderType,
    );

    return filtered;
  };

  const filterCustomFieldsByUserRole = (
    customFields: OrderConditionCustomFieldConfig[],
    userRole?: UserRole,
  ): OrderConditionCustomFieldConfig[] => {
    const filtered = customFields.filter(
      ({ visibleToRoles }) =>
        !visibleToRoles.length || visibleToRoles.some((role) => role === userRole),
    );

    return filtered;
  };

  const filterCustomFieldsByOrderConditionAndUserRole = ({
    userRole,
    orderCondition,
    orderConditionCustomFields,
  }: FilterCustomFieldsByOrderConditionAndUserRoleParams): OrderConditionCustomFieldConfig[] => {
    const filteredByOrderCondition = filterCustomFieldsByOrderCondition(
      orderConditionCustomFields,
      orderCondition,
    );
    const filteredByOrderConditionAndUserRole = filterCustomFieldsByUserRole(
      filteredByOrderCondition,
      userRole,
    );
    return filteredByOrderConditionAndUserRole;
  };

  return { filterCustomFieldsByOrderConditionAndUserRole };
};

export default useFilterOrderConditionCustomFields;
